import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatSort, Sort } from '@angular/material/sort';

import { Mapper, NgUtils, TiimePipesModule } from 'tiime-expert-utils';
import {
  ContainerState,
  TableAnchorComponent,
  TiimeButtonModule,
  TiimeIconModule,
  TiimeSortModule,
  TiimeTableModule,
  TiimeTooltipModule
} from 'tiime-material';

import { Document } from '@models/document';
import { ColumnNames } from '@modules/company/documents-and-editions/documents/documents.columns';
import { CommentCellComponent } from '@modules/shared/cells/comment-cell/comment-cell.component';
import { DocumentCategoryIdentifierIconModule } from '@shared-components/document-category-identifier-icon/document-category-identifier-icon.module';
import { TagListIconModule } from '@shared-components/tag-list-icon/tag-list-icon.module';

@Component({
  selector: 'app-documents-table',
  standalone: true,
  imports: [
    CommonModule,
    TiimeTableModule,
    TiimeTooltipModule,
    TiimeButtonModule,
    TiimePipesModule,
    TiimeSortModule,
    TiimeIconModule,
    CommentCellComponent,
    TagListIconModule,
    DocumentCategoryIdentifierIconModule
  ],
  templateUrl: './documents-table.component.html',
  styleUrls: ['./documents-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentsTableComponent {
  @Input() documents: Document[];
  @Input() displayedColumns: string[];
  @Input() containerState: ContainerState;

  @Output() readonly applySort: EventEmitter<Sort> = new EventEmitter<Sort>();
  @Output() readonly openDocumentDialog: EventEmitter<Document> = new EventEmitter<Document>();
  @Output() readonly deleteDocument: EventEmitter<Document> = new EventEmitter<Document>();

  @ViewChild(TableAnchorComponent) tableAnchorComponent: TableAnchorComponent;
  @ViewChild(MatSort) sort: MatSort;

  scrollContainer: HTMLElement;

  readonly ColumnNames = ColumnNames;
  readonly trackById = NgUtils.trackById;

  readonly mapToDisabledSort: Mapper<ContainerState, boolean> = (containerState: ContainerState) =>
    containerState !== ContainerState.done;

  constructor(elementRef: ElementRef) {
    this.scrollContainer = elementRef.nativeElement;
  }

  emitApplySort(sortValue: Sort): void {
    this.applySort.emit(sortValue);
  }

  emitOpenDocumentDialog(document: Document): void {
    this.openDocumentDialog.emit(document);
  }

  emitDeleteDocument(document: Document): void {
    this.deleteDocument.emit(document);
  }

  resetSort(): void {
    this.sort?.sort({ id: null, start: 'asc', disableClear: false });
  }
}
